import React from 'react';
import { useHistory } from 'react-router-dom';

import { ReactComponent as PokerFaceIcon } from '../../../styles/icon/poker-face.svg';
import { useAppSelector } from '../../../hooks/useRedux';
import { appDetailsData } from '../../../redux/reducers/apps';
import { webhooksList } from '../../../redux/reducers/webhooks';
import Routes from "../../../components/Routes";
import strings from '../../../lang/lang';
import settings from '../Settings.module.scss';

function WebhookTable() {
  const history = useHistory();
  const data = useAppSelector(appDetailsData);
  const webhookList = useAppSelector(webhooksList);

  if (!webhookList.length) {
    return (
      <div>
        <PokerFaceIcon />
        <h4>{strings.appWebhooks.text.noWebhooks}</h4>
      </div>
    );
  }

  const appId = data['id'];

  return (
    <div className={settings.settings__wrap_webhooks_table}>
      <table>
        <tbody>
          {webhookList.map((item) => {
            return (
              <tr
                key={item.id}
                onClick={() => {
                  history.push(
                    Routes.routes.WEBHOOKDETAILS.path
                      .replace(':id', appId)
                      .replace(':webhookId', item.id)
                  );
                }}
              >
                <td>{item.eventTypeName}</td>
                <td style={{ minWidth: 150 }}>{item.status}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default WebhookTable;
